/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-14 17:59:50
 * @LastEditors: taoyuan taoyuan@originqc.com
 * @LastEditTime: 2022-12-14 20:21:11
 * @FilePath: \qcloud-web-pc-4.0\src\utils\client.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import JSEncrypt from 'jsencrypt';

// 随机生成六位数
export const RandomNormal = () => {
  let RandomNormalStr = '';
  for (let i = 0; i < 6; i++) {
    RandomNormalStr += String(Math.floor(Math.random() * 10));
  }
  return RandomNormalStr;
};
// 生成header加密内容
export const RSA_SIGNATURE = (data) => {
  const BZUJson = {};
  const bzrCts = Date.now() + 20170911;
  const bzrCdm = RandomNormal();
  const encryptor = new JSEncrypt(); // 创建加密对象实例
  //之前ssl生成的公钥，复制的时候要小心不要有空格
  const O1v = 'BEGIN PUBLIC KEY';
  const Ose = 'END PUBLIC KEY';
  const Oqs = [
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCP+hXVBiEeROxps',
    'JSzeDFynMqO/cHG1Hw06q3zo+eC0apx+a5/RqLJK8X9cwJy12/OABO5M',
    'u4gySYj0o2mzeOOjx1GL4wMokIAkGtQTzA3UnfF/twMMYVHQUPUBiOU8+z',
    'w1OqVmSJgZDqWqQZFmh9u9NcMDNrKnbYMYGMBkGeT0wIDAQAB',
  ];
  const other = `-----${O1v}-----${Oqs.join('')}-----${Ose}-----`;
  encryptor.setPublicKey(other); //设置公钥
  const bySign = encryptor.encrypt(
    `cts=${bzrCts}&rdm=${bzrCdm}&tel=${data.tel}&type=${data.type}`
  );
  BZUJson.rdm = bzrCdm;
  BZUJson.cts = bzrCts;
  setCookie('originqsig', bySign);

  return BZUJson;
};

function setCookie(name, value) {
  const Days = 30;
  const exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 30);
  document.cookie =
    name +
    '=' +
    encodeURIComponent(value) +
    ';expires=' +
    exp.toGMTString() +
    ';path=/';
}
